import type { CatalogCategoryKindType, CatalogDirActionResultType } from '@econtractor/types';
import * as apiProducts from 'api/apiProducts';
import * as apiProductSets from 'api/apiProductSets';
import * as apiServices from 'api/apiServices';

type CatalogDirClient = {
    getUsage: () => Promise<Record<number, number> | null>;
    create: (name: string) => Promise<CatalogDirActionResultType | null>;
    rename: (dirId: number, name: string) => Promise<CatalogDirActionResultType | null>;
    delete: (dirId: number) => Promise<CatalogDirActionResultType | null>;
};

export const CATALOG_DIR_I18N_NS: Record<CatalogCategoryKindType, 'Products' | 'Sets' | 'Services'> = {
    product: 'Products',
    set: 'Sets',
    service: 'Services',
};

export const catalogDirApi: Record<CatalogCategoryKindType, CatalogDirClient> = {
    product: {
        getUsage: apiProducts.getDirUsage,
        create: apiProducts.createDir,
        rename: apiProducts.renameDir,
        delete: apiProducts.deleteDir,
    },
    set: {
        getUsage: apiProductSets.getDirUsage,
        create: apiProductSets.createDir,
        rename: apiProductSets.renameDir,
        delete: apiProductSets.deleteDir,
    },
    service: {
        getUsage: apiServices.getDirUsage,
        create: apiServices.createDir,
        rename: apiServices.renameDir,
        delete: apiServices.deleteDir,
    },
};
